const MAX_DIGITS = 10;
const SLASH_INDEX = 6;

/**
 * parseRc - Strips everything but digits from a rodné číslo input and caps it at 10 digits.
 *
 * @param {string} value  raw input value (may contain the display slash)
 */
export function parseRc(value) {
  return (value || '').replace(/\D/g, '').slice(0, MAX_DIGITS);
}

/**
 * formatRc - Formats digits-only rodné číslo for display as YYMMDD/XXXX.
 *
 * @param {string} value  digits-only (or raw) rodné číslo value
 */
export function formatRc(value) {
  const digits = parseRc(value);
  return digits.length > SLASH_INDEX
    ? `${digits.slice(0, SLASH_INDEX)}/${digits.slice(SLASH_INDEX)}`
    : digits;
}

/**
 * rcFieldDecoratorOptions - getFieldDecorator options that keep the antd/rc-form field value
 * digits-only while displaying it with the conventional slash.
 */
export const rcFieldDecoratorOptions = {
  getValueFromEvent: e => parseRc(e.target.value),
  getValueProps: value => ({ value: formatRc(value) }),
};

/**
 * createRcBackspaceHandler - onKeyDown handler so Backspace right after the display slash
 * removes the digit before it, instead of just eating the (non-stored) slash character.
 *
 * @param {object} form       antd/rc-form form instance
 * @param {string} fieldName  name of the getFieldDecorator field
 */
export function createRcBackspaceHandler(form, fieldName) {
  return e => {
    if (e.key !== 'Backspace') return;

    const el = e.target;
    if (el.selectionStart !== el.selectionEnd) return;
    if (el.selectionStart < 1 || el.value[el.selectionStart - 1] !== '/') return;

    e.preventDefault();
    const digits = parseRc(el.value);
    const newDigits = digits.slice(0, SLASH_INDEX - 1) + digits.slice(SLASH_INDEX);
    form.setFieldsValue({ [fieldName]: newDigits });

    const restoreCursor = () => {
      el.selectionStart = el.selectionEnd = SLASH_INDEX - 1;
    };
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(restoreCursor);
    } else {
      setTimeout(restoreCursor, 0);
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/utils/rcMask.js